module.exports = __webpack_public_path__ + "img/logo-dark.923bf3cf.png";